import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { DateInput, Input, Select, SelectLabel, TimeInput } from '../../styled-components';
import { actions as axisOrderActions } from '../../actions/axisOrder';
import { localizeAxis as localize } from '../../util/localizeUtils';

const PRIORITIES = [
  { id: 1, name: localize('priorityUrgentOption') },
  { id: 2, name: localize('priorityHighOption') },
  { id: 3, name: localize('priorityNormalOption') },
  { id: 4, name: localize('priorityLowOption') }
];

const InputRow = styled.div`
  margin-bottom: 0.25rem;
`;

const InputLabel = styled.div`
  display: inline-block;
  letter-spacing: -.25px;
  width: 5.25rem;
`;

const HalfWidthDiv = styled.div`
  display: inline-block;
  width: 12rem;
`;

const LeftDiv = styled(HalfWidthDiv) `
  margin-right: .25rem;
`;

const RightDiv = styled(HalfWidthDiv) `
  margin-left: .25rem;
`;

class OrderDetails extends Component {
  constructor() {
    super();
    this.updateCount = 0;
  }
  componentDidUpdate() {
    if (this.textInput && this.updateCount <= 2) {
      this.textInput.focus();
      this.updateCount += 1;
    }
  }
  render() {
    const invalidInputStyle = {
      border: '2px solid red'
    };

    const inputStyle = this.props.highlightErrors && !this.props.title ? invalidInputStyle : {};

    return (
      <div>
        <InputRow>
          <InputLabel>{localize('titleLabel')}</InputLabel>
          <Input
            ref={(input) => { this.textInput = input; }}
            type="text"
            style={inputStyle}
            width="19.25rem"
            value={this.props.title}
            onChange={(event) => this.props.onChangeTitle(event.target.value)}
            required
          />
        </InputRow>
        <InputRow>
          <LeftDiv>
            <SelectLabel htmlFor="project-select">{localize('projectLabel')}</SelectLabel>
            <Select
              labelPadding="3.75rem"
              id="project-select"
              width="100%"
              onChange={(event) => this.props.onChangeProject(event.target.value)}
              value={this.props.selectedProject}
              required
            >
              {
                this.props.projects.map((project) =>
                  <option key={project.id} value={project.id}>{project.name}</option>)
              }
            </Select>
          </LeftDiv>
          <RightDiv>
            <SelectLabel htmlFor="priority-select">{localize('priorityLabel')}</SelectLabel>
            <Select
              labelPadding="3.75rem"
              id="priority-select"
              width="100%"
              onChange={(event) => this.props.onChangePriority(event.target.value)}
              value={this.props.selectedPriority}
              required
            >
              {
                PRIORITIES.map(priority =>
                  <option key={priority.id} value={priority.id}>{priority.name}</option>
                )
              }
            </Select>
          </RightDiv>
        </InputRow>
        <InputRow>
          <LeftDiv>
            <InputLabel>{localize('deadlineLabel')}</InputLabel>
            <DateInput
              type="date"
              min={getMinDate()}
              value={this.props.deadline.date}
              onChange={(event) => this.props.onChangeDeadlineDate(event.target.value)}
              required
            />
          </LeftDiv>
          <RightDiv>
            <TimeInput
              type="time"
              step={900}
              value={this.props.deadline.time}
              onChange={(event) => this.props.onChangeDeadlineTime(event.target.value)}
              required
            />
          </RightDiv>
        </InputRow>
      </div>
    );
  }
}

const getMinDate = () => new Date().toISOString().split('T')[0];

OrderDetails.defaultProps = {
  deadline: {},
  highlightErrors: false,
  title: ''
};

OrderDetails.propTypes = {
  onChangeDeadlineDate: PropTypes.func.isRequired,
  onChangeDeadlineTime: PropTypes.func.isRequired,
  onChangePriority: PropTypes.func.isRequired,
  onChangeProject: PropTypes.func.isRequired,
  onChangeTitle: PropTypes.func.isRequired,
  deadline: PropTypes.shape({
    date: PropTypes.string,
    time: PropTypes.string
  }),
  highlightErrors: PropTypes.bool.isRequired,
  projects: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired
  })).isRequired,
  selectedPriority: PropTypes.number.isRequired,
  selectedProject: PropTypes.string.isRequired,
  title: PropTypes.string
};

const mapStateToProps = (state) => ({
  deadline: state.axisOrder.deadline,
  projects: state.axisOrder.projects,
  selectedPriority: state.axisOrder.selectedPriority,
  selectedProject: state.axisOrder.selectedProject,
  title: state.axisOrder.title
});

const mapDispatchToProps = {
  onChangeDeadlineDate: axisOrderActions.changeDeadlineDate,
  onChangeDeadlineTime: axisOrderActions.changeDeadlineTime,
  onChangePriority: axisOrderActions.changePriority,
  onChangeProject: axisOrderActions.changeProject,
  onChangeTitle: axisOrderActions.changeTitle
};

export default connect(mapStateToProps, mapDispatchToProps)(OrderDetails);



// WEBPACK FOOTER //
// ./app/components/OrderForm/OrderDetails.js